import { createContext } from 'react';
import { Context } from './types';

export const MapContext = createContext<Context | undefined>(undefined);
